import React, {FC} from 'react'

export const TextIcon: FC = () => (
    <svg className='canvas-toolbar__icon' viewBox='0 0 24 24' fill='none' stroke='currentColor' strokeWidth='2' strokeLinecap='round' strokeLinejoin='round'>
        <polyline points='4 7 4 4 20 4 20 7'/>
        <line x1='9' y1='20' x2='15' y2='20'/>
        <line x1='12' y1='4' x2='12' y2='20'/>
    </svg>
)
